import React, { useState } from 'react';
import { FormElement, FormSelector, FormLabel, FormInput, FormNumberInput, PageSubTitle } from "../components/StyledElements";
import { Handle, Position } from '@xyflow/react';
import { NodeCard } from './NodeCard';
import { CloseButton } from '../components/CloseButton';

export const TransformTextNodeCard = ({ onAdd = () => { }, style = {} }) => {
  return (
    <NodeCard title="Transform Text Node" description="Command to Transform Text" onAdd={onAdd} style={style} />
  )
};

export const TransformTextNode = ({ id, data }) => {
  const [transformType, setTransformType] = useState(data.transformType || "code");

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)" }}>
      <CloseButton onClick={() => {
        data.onDelete(id);
      }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <FormElement>
          <FormLabel label="Transform Type" />
          <FormSelector value={transformType}
            options={[
              { value: "code", label: "Custom Python Code" },
              { value: "llm", label: "LLM Prompt" },
              // You can add more predefined transformation types here
            ]}
            onChange={(e) => {
              setTransformType(e.target.value);
            }}
          />
        </FormElement>
        {
          transformType === "code" && (
            <FormElement style={{ width: "400px" }}>
              <FormLabel label="Transform Text Python Code" />
              <FormInput value={data.transformCode || ""}
                as="textarea"
                style={{ fontFamily: "monospace", height: "150px" }}
                onChange={(e) => {
                  data.onChange(id, { ...data, transformCode: e.target.value });
                }}
                placeholder={``}
              />
            </FormElement>
          )}
        {
          transformType === "llm" && (
            <FormElement style={{ width: "400px" }}>
              <FormLabel label="LLM Instructions" />
              <FormInput value={data.transformPrompt || ""}
                as="textarea"
                style={{ fontFamily: "monospace", height: "150px" }}
                onChange={(e) => {
                  data.onChange(id, { ...data, transformPrompt: e.target.value });
                }}
                placeholder={``}
              />
            </FormElement>
          )}
      </div>
      <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} />
      <Handle type="source" position={Position.Right} style={{ height: "12px", width: "12px" }} id="document-chunks" />
    </div>
  );
};

export default TransformTextNode;
